<template>
  <div class="permision-tips" :style="{height: windowHeight + 'px'}">
    <div class="pt-content">
      <div class="pt-icon">
        <svg  width="64" height="64" viewBox="0 0 64 64">
          <g fill="none" fill-rule="nonzero">
            <path fill="#D2D2D2" d="M6 0h38.148a8 8 0 0 1 8 8v.296H0V6a6 6 0 0 1 6-6z" opacity=".662"/>
            <path fill="#F5F5F5" d="M11.852 8.296C11.852 3.556 9.877.79 5.926 0h43.778a8 8 0 0 1 8 8v50a6 6 0 0 1-6 6H19.852a8 8 0 0 1-8-8V8.296z"/>
            <path fill="#D8D8D8" d="M18.5 10h33a1.5 1.5 0 0 1 0 3h-33a1.5 1.5 0 0 1 0-3zm0 8h30a1.5 1.5 0 0 1 0 3h-30a1.5 1.5 0 0 1 0-3zm0 8h18a1.5 1.5 0 0 1 0 3h-18a1.5 1.5 0 0 1 0-3zm0 8h26a1.5 1.5 0 0 1 0 3h-26a1.5 1.5 0 0 1 0-3zm0 8h10a1.5 1.5 0 0 1 0 3h-10a1.5 1.5 0 0 1 0-3zm0 8h17a1.5 1.5 0 0 1 0 3h-17a1.5 1.5 0 0 1 0-3z" opacity=".44"/>
            <path fill="#E1E1E1" d="M20 64a8 8 0 0 0 8-8h36a8 8 0 0 1-8 8H20z"/>
            <circle cx="36" cy="31" r="13" fill="#D2D2D2"/>
            <circle cx="36" cy="31" r="10" fill="#F5F5F5"/>
            <path fill="#D2D2D2" d="M45.695 24l1.5 2.599L27.5 37.969 26 35.373z"/>
            <circle cx="4.5" cy="40.5" r="1.5" fill="#F5F5F5"/>
            <circle cx="61.5" cy="29.5" r="1.5" fill="#F5F5F5"/>
          </g>
        </svg>
      </div>
      <div v-html="overFreeViewMessage"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'PermissionTips',
    data() {
        return {
            windowHeight: 0
        };
    },
    computed: {
        ...mapGetters(['overFreeViewMessage'])
    },
    created() {
        this.windowHeight = window.innerHeight;
    }
};
</script>

<style scoped>
.permision-tips {
    width: 100%;
    height: 100%;
    position: relative;
}

.pt-icon {
    margin-bottom: 20px;
    display: block;
}

.pt-content {
    position: absolute;
    top: 30%;
    left: 50%;
    margin-left: -300px;
    width: 600px;
    text-align: center;
}
</style>
